import React from 'react';
import { OpenInNewRounded } from '@material-ui/icons';

/** 新視窗按鈕 props */
interface OpenNewWindowButtonProps {
  /** 點擊按鈕後要打開的網址，必須是完整的 URL（例如：https://www.example.com）。如果未提供或為 null，按鈕將不會顯示。 */
  url?: string | null;
  /** 可選的 CSS 類名，用於自定義按鈕樣式。如果未提供，預設使用 'nw' 類名。 */
  className?: string;
  /** 是否已由父層 sidebar 項目啟用開新視窗功能。 */
  isNewWindowEnabled?: boolean;
}

/**
 * 新視窗按鈕組件
 * @param props - 按鈕配置參數
 */
function OpenNewWindowButton(props: OpenNewWindowButtonProps) {
  const { url, className, isNewWindowEnabled = false } = props;

  if (!url || url.trim() === '/DividingLine/DividingLineIndex') {
    //console.warn("OpenNewWindowButton: 未提供 url 屬性");
    return null; // 或者返回一個預設的按鈕
  }

  return (
    <span
      className={className || 'nw'}
      style={{
        cursor: 'pointer',
        padding: '4px 8px',
        marginLeft: '10px',
        zIndex: 10,
        color: isNewWindowEnabled ? '#000000' : '#00000000',
        transition: 'color 0.2s',
        WebkitTapHighlightColor: 'transparent', // 移除手機點擊時的藍色高亮
      }}
      onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
        if (!isNewWindowEnabled) return;

        e.preventDefault();
        e.stopPropagation();
        window.open(url, '_blank');
      }}
    >
      <OpenInNewRounded fontSize="small" />
    </span>
  );
};

export default OpenNewWindowButton;